import {
  LoadingContainer,
  Panels,
  Bar,
  Model,
  Breadcrumb,
  LegacyPage,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams, useRouteMatch } from 'peach/router'

import { useInternalBorrowerPaymentInstrumentGet } from 'core/types'

const PaymentInstrument = () => {
  const { url } = useRouteMatch()
  const { companyId, personId, paymentInstrumentId } = useParams<{
    companyId?: string
    personId?: string
    paymentInstrumentId?: string
  }>()

  const {
    data: paymentInstrument,
    isLoading,
    error,
  } = useInternalBorrowerPaymentInstrumentGet({
    companyId,
    personId,
    paymentInstrumentId,
  })

  const name = getName(paymentInstrument)
  const header = <Bar title={name} />

  return (
    <Panels header={header}>
      <Breadcrumb title={name} to={url} />
      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage.Full>
          <Model.Item json={paymentInstrument} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default PaymentInstrument
